import { render } from "./starting-point-affiliate.vue?vue&type=template&id=60c78658&scoped=true&ts=true"
import script from "./starting-point-affiliate.vue?vue&type=script&lang=ts"
export * from "./starting-point-affiliate.vue?vue&type=script&lang=ts"

import "./starting-point-affiliate.vue?vue&type=style&index=0&id=60c78658&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c78658"]])

export default __exports__